import InstagramInstantwinAnalyticsPublicCampaign from './InstagramInstantwinAnalyticsPublicCampaign.vue'
export default InstagramInstantwinAnalyticsPublicCampaign
